function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappFlashcardCount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 12,
  viewBox: "0 0 12 12"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "evenodd",
    fill: "#58636a",
    fillOpacity: 1
  },
  d: "M6.105.063c-.375.019-.69.304-.773.69-.508 2.411-.644 4.036-.547 6.5.02.392.277.727.64.817 1.747.434 2.954.547 4.743.446.379-.024.691-.313.77-.704.468-2.39.605-4 .542-6.468a.873.873 0 0 0-.652-.84C9.094.094 7.887-.027 6.105.062Zm-2.523 2.68c.148-.052.297.081.277.245-.171 1.375-.21 2.672-.144 4.313.039.894.633 1.66 1.465 1.867 1.078.27 1.972.422 2.906.48.055.004.078.079.027.106-1.578.894-2.718 1.332-4.472 1.719a.826.826 0 0 1-.91-.457C1.647 8.828 1.116 7.296.604 4.886a.894.894 0 0 1 .422-.968c.934-.52 1.711-.883 2.555-1.176Zm0 0"
}));
export default SvgWebappFlashcardCount;